import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-nav-footer',
    templateUrl: './page-nav-footer.component.html',
    styleUrls: ['./page-nav-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNavFooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
